import React, { FC } from 'react';
import { Author as AuthorData } from '../../../../shared/types';
import { getLinkAttributes } from '../helpers';

import './index.scss';

type AuthorProps = Partial<AuthorData>;

export const Author: FC<AuthorProps> = ({ webLink, photo, heading, authorName, title, biography }) => {
  const { image, alt } = photo || {};
  const linkAttrs = getLinkAttributes(webLink);
  const photoNode = image ? <img src={image} alt={alt} /> : null;

  return (
    <div className="about-author">
      <div className="title">
        {photoNode &&
          (webLink ? (
            <a href={webLink} {...linkAttrs}>
              {photoNode}
            </a>
          ) : (
            photoNode
          ))}
        <div>
          {heading && <h2>{heading}</h2>}
          <h4>
            {authorName}
            {title &&
              (webLink ? (
                <a href={webLink} {...linkAttrs}>
                  {title}
                </a>
              ) : (
                <span>{title}</span>
              ))}
          </h4>
        </div>
      </div>
      {biography && <p>{biography}</p>}
    </div>
  );
};
